export const distribuidores = {
"Puerto Vallarta, Jalisco": {
    lat: 20.69069093169624,
    lng: -105.25202318096603,
    direccion: "Carretera a Tepic #5800, Colonia Las Juntas, C.P. 48291 Puerto Vallarta, Jalisco.",
    telefono: "(322)-221-4015",
    email: "jaberecochea@bestunepuertovallarta.com.mx",
    fb: "https://www.facebook.com/people/Bestune-Puerto-Vallarta/61565420464556/",
    ig: "https://www.instagram.com/bestune_puertovallarta/"
  },
  "Tepic, Nayarit": {
    lat: 21.494139868982593,
    lng: -104.87913984595599,
    direccion: "Av. Independencia #353, Col. Los Llanitos, C.P. 63170, Tepic, Nayarit.",
    telefono: "(311)-180-6989",
    email: "jaberecochea@bestunetepic.com.mx",
    fb: "https://www.facebook.com/people/Bestune-Tepic/61565525549664/",
    ig: "https://www.instagram.com/bestune.tepic/"
  },

};
